<template>
  <main class="admin-request">
    <div class="admin-request__wrapper">
      <div class="admin-request__heading">
        <h1 class="admin-request__page-title">Заявка</h1>
        <router-link
          class="admin-request__back"
          :to="{ name: 'AdminRequests' }"
        >
          Ко всем заявкам →
        </router-link>
      </div>
      <div class="admin-request__container">
        <div class="admin-request__data">
          <span class="admin-request__data-title">Имя</span>
          <span :title="request.name" class="admin-request__data-value admin-request__data-value_bold">{{ request.name }}</span>
          <span class="admin-request__data-title">Город</span>
          <span :title="request.location" class="admin-request__data-value">{{ request.location }}</span>
          <span class="admin-request__data-title">Телефон</span>
          <span :title="request.phone" class="admin-request__data-value">{{ request.phone }}</span>
          <span class="admin-request__data-title">Email</span>
          <a
            target="_blank"
            :title="request.email"
            :href="`mailto:${request.email}`"
            class="admin-request__data-value admin-request__data-value_link"
          >
            {{ request.email }}
          </a>
          <span class="admin-request__data-title">Ссылка</span>
          <a
            target="_blank"
            :title="request.link"
            :href="request.link"
            class="admin-request__data-value admin-request__data-value_link"
          >
            {{ request.link }}
          </a>
          <span class="admin-request__data-title">Возраст</span>
          <span :title="request.age" class="admin-request__data-value">{{ request.age }}</span>
          <span class="admin-request__data-title">Рост</span>
          <span :title="request.height" class="admin-request__data-value">{{ request.height }}</span>
          <span class="admin-request__data-title">Фото</span>
          <span
            @click="downloadImages"
            class="admin-request__data-value admin-request__data-value_link"
          >
            Скачать
          </span>
        </div>
        <div class="admin-request__button-wrapper">
          <base-button
            v-show="!request.isArchived"
            @click="showPopup = true"
            class="admin-request__reject-btn"
          >отклонить</base-button>
        </div>
        <div class="admin-request__images-wrapper">
          <div class="admin-request__images">
            <div class="admin-request__image-wrapper">
              <img class="admin-request__image" :src="request.images.nomakeup1.previewUrl">
            </div>
            <div class="admin-request__image-wrapper">
              <img class="admin-request__image" :src="request.images.nomakeup2.previewUrl">
            </div>
            <div class="admin-request__image-wrapper">
              <img class="admin-request__image" :src="request.images.nomakeup3.previewUrl">
            </div>
            <div class="admin-request__image-wrapper">
              <img class="admin-request__image" :src="request.images.portrait.previewUrl">
            </div>
            <div class="admin-request__image-wrapper">
              <img class="admin-request__image" :src="request.images.fullHeight1.previewUrl">
            </div>
            <div class="admin-request__image-wrapper">
              <img class="admin-request__image" :src="request.images.fullHeight2.previewUrl">
            </div>
          </div>
        </div>
      </div>
    </div>
    <reject-popup
      :isShown="showPopup"
      @cancel-rejection="showPopup = false"
      @reject="rejectRequest"
    ></reject-popup>
  </main>
</template>

<script>
import JSZip from 'jszip'
import saveAs from 'file-saver'
import BaseButton from '../components/BaseButton'
import RejectPopup from '../components/RejectPopup'
import { apiGetRequest, apiSeeRequest, apiRejectRequest } from '../utils/api'
import { CHANGE_NEW_REQUESTS } from '../store/mutations-names'

export default {
  name: 'AdminRequestView',
  components: {
    BaseButton,
    RejectPopup
  },
  data() {
    return {
      showPopup: false,
      isDownloading: false,
      request: {
        name: '',
        location: '',
        phone: '',
        email: '',
        link: '',
        age: '',
        height: '',
        notSeen: false,
        isArchived: false,
        images: {
          nomakeup1: { url: '', filePath: ''},
          nomakeup2: { url: '', filePath: ''},
          nomakeup3: { url: '', filePath: ''},
          portrait: { url: '', filePath: ''},
          fullHeight1: { url: '', filePath: ''},
          fullHeight2: { url: '', filePath: ''},
        }
      }
    }
  },
  async mounted() {
    try {
      const request = await apiGetRequest(this.$route.params.id)
      this.request = request
      if (!/^https?:\/\//.test(this.request.link)) {
        this.request.link = 'https://' + this.request.link
      }
    } catch(e) {
      console.error(e.message)
      this.$router.push({ name: 'AdminRequests' })
      return
    }
    // change notSeen to false if first view
    if (this.request.notSeen) {
      try {
         await apiSeeRequest(this.$route.params.id)
         this.$store.commit(CHANGE_NEW_REQUESTS, this.$store.state.newRequests - 1)
      } catch(e) {
        console.error(e.message)
      }
    }
  },
  methods: {
    async rejectRequest() {
      try {
        const result = await apiRejectRequest(this.$route.params.id)
        if (result) {
          this.$router.push({ name: 'AdminRequests' })
        }
      } catch (e) {
        console.error(e.message)
      }
    },
    async downloadImages() {
      if (this.isDownloading) {
        return
      }
      this.isDownloading = true
      const zip = new JSZip()
      for (let key in this.request.images) {
        try {
          const response = await fetch(this.request.images[key].url, {
            headers: {
              'Authorization': `Bearer ${localStorage.getItem('token')}`
          }})
          if (response.status == 200) {
            const blob = await response.blob()
            const blobType = blob.type == '' ? '' : blob.type.split('/')[1]
            zip.file(`photos/${key}.` + blobType, blob)
          }
  
        } catch(e) {
          console.error(e.message)
        }
      }
      const zipFile = await zip.generateAsync({ type: 'blob' })
      saveAs(zipFile, 'request.zip')
      this.isDownloading = false
    }
  }
}
</script>

<style lang="scss" scoped>
@use "../styles/fonts";
@use "../styles/colors";

.admin-request {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 60px 45px 40px;
  &__wrapper {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 1328px;
  }
  &__heading {
    margin-bottom: 30px;
  }
  &__page-title {
    display: inline-block;
    font-size: 22px;
    line-height: 40px;
    text-transform: uppercase;
    margin-right: 20px;
  }
  &__back {
    text-decoration: none;
    color: colors.$blue03;
  }
  &__container {
    flex-grow: 1;
    display: grid;
    grid-template-columns: 0.5fr 1fr;
    grid-template-rows: auto 1fr;
    column-gap: 65px;
    row-gap: 36px;
  }
  &__data {
    grid-column: 1 / 2;
    grid-row: 1 / 2;
    display: grid;
    grid-template-columns: 115px minmax(250px, 1fr);
    grid-template-rows: repeat(8, 16px);
    row-gap: 20px;
  }
  &__button-wrapper {
    grid-column: 1 / 2;
    grid-row: 2 / 3;
  }
  &__reject-btn {
    margin-left: 115px;
  }
  &__images-wrapper {
    grid-column: 2 / 3;
    grid-row: 1 / 3;
  }
  &__images {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));
    column-gap: 10px;
    row-gap: 10px;
    justify-content: end;
    overflow-y: scroll;
  }
  &__data-title {
    font-size: 16px;
    color: colors.$gray7f;
  }
  &__data-value {
    font-size: 16px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    &_bold {
      @include fonts.mo-med;
    }
    &_link {
      color: colors.$blue03;
      cursor: pointer;
    }
  }
  &__image-wrapper {
    position: relative;
    padding-top: 120%;

  }
  &__image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    background-color: colors.$grayef;
  }
}

@media screen and (max-width: 1023px) {
  .admin-request {
    padding: 50px 12px 25px;
    &__container {
      grid-template-columns: 1fr;
      grid-template-rows: auto;
      row-gap: 25px;
    }
    &__data {
      grid-column: 1 / 2;
      grid-row: 1 / 2;
      grid-template-columns: 115px auto;
    }
    &__button-wrapper {
      grid-column: 1 / 2;
      grid-row: 3 / 4;
    }
    &__reject-btn {
      margin: 0;
      width: 100%;
    }
    &__images-wrapper {
      grid-column: 1 / 2;
      grid-row: 2 / 3;
    }
    &__images {
      grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
      justify-content: start;
    }
  }
}
</style>